import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import LoginComponent from "../../components/Login";
import * as modalActions from "../../redux/actions/modalActions";
import * as loginActions from "../../redux/actions/loginActions";
import PropTypes from "prop-types";
import * as utilities from "../../utilities/utils";
import history from "../../utilities/history";
import GoogleAuth from "../GoogleAuth";
import TermsAndConditionsPage from "./TermsAndConditions";
import { MODAL_SIZE } from "../../App.config";

const Login = (props, context) => {
  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);
  const loginAction = bindActionCreators(loginActions, dispatch);
  const loginReducer = useSelector((state) => state.loginReducer);
  const profileReducer = useSelector((state) => state.profileReducer);

  ///Remove already stored token from localstorage
  useEffect(() => {
    localStorage.clear('AUTH_TOKEN');
    // if(localStorage.getItem("AUTH_TOKEN")){
    //   history.push("/dashboard");  
    // }
  }, []);

  const openSetModal = (children, size) => {
    modalAction.openSetModal(children, size);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const varifyLogin = (credentialDetails) => {
    loginAction.varifyLogin(credentialDetails);
  };


  const resetIsPasswordExpired = (isPasswordExpired) => {
    loginAction.resetIsPasswordExpired(isPasswordExpired);
  }

  const isLoginSuccessfull = (isLogin) => {
    loginAction.isLoginSuccessfull(isLogin);
  }

  return (
    <>
      <LoginComponent
        varifyLogin={varifyLogin}
        isAuthenticating={loginReducer.isAuthenticating}
        isAuthenticated={loginReducer.isAuthenticated}
        isAuthenticationFailed={loginReducer.isAuthenticationFailed}
        isSessionValid={loginReducer.isSessionValid}
        isPasswordExpired={loginReducer.isPasswordExpired}
        openSetModalAction={openSetModal}
        context={context}
        resetIsPasswordExpired={resetIsPasswordExpired}
        loginReducer={loginReducer}
        isLoginSuccessfull={isLoginSuccessfull}
        profileReducer={profileReducer}
      />

      
    </>

  );
};

Login.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Login;
